import { render, staticRenderFns } from "./confirm.modal.vue?vue&type=template&id=08b8afe1&"
import script from "./confirm.modal.vue?vue&type=script&lang=ts&"
export * from "./confirm.modal.vue?vue&type=script&lang=ts&"
import style0 from "./confirm.modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports